export default __webpack_public_path__ + "static/media/1820.bf17e372.png";